import axios, { AxiosError } from "axios";

import { ErrorMessage } from "src/types";
import CustomError from "src/app/libs/customError";
import { showErrorToast } from "./methods";

const isErrorMessage = (error: unknown): error is ErrorMessage => {
  if (typeof error !== "object" || error === null) {
    return false;
  }

  if (!("field" in error) || !("message" in error) || !("type" in error)) {
    return false;
  }

  return (
    typeof error.field === "string" &&
    typeof error.message === "string" &&
    typeof error.type === "string"
  );
};

export function formatAxiosErrors(error: AxiosError): ErrorMessage[] {
  if (error.response?.data) {
    const errorData: unknown = error.response.data;
    if (
      typeof errorData === "object" &&
      errorData !== null &&
      "errors" in errorData &&
      Array.isArray(errorData.errors) &&
      errorData.errors.every(isErrorMessage)
    ) {
      return errorData.errors;
    }
  }

  throw new CustomError({
    id: "ws_something_went_wrong",
    defaultMessage: "An unexpected error occurred.",
  });
}

export function handleError(error: unknown) {
  if (error instanceof CustomError) {
    showErrorToast(error);
  } else if (axios.isAxiosError(error)) {
    try {
      const errorMessages = formatAxiosErrors(error);
      errorMessages.forEach((errorMessage) => {
        showErrorToast({
          id: errorMessage.message,
          defaultMessage: errorMessage.message,
        });
      });
    } catch {
      showErrorToast();
    }
  } else {
    showErrorToast();
  }
}
